import React from "react";
import { Link } from "react-router-dom";

function Services() {
  return (
    <section className="services-section-two bg-blue pb-60">
      <div className="container">
        <div className="service-two-wrap">
          <div className="row justify-content-center">
            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-1-1s">
                <div className="icon">
                  <i className="flaticon flaticon-web"></i>
                </div>
                <h6>
                  <Link to="/services">Web Service</Link>
                </h6>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-0-7s">
                <div className="icon">
                  <i className="flaticon flaticon-seo-1"></i>
                </div>
                <h6>
                  <Link to="/services">Digital Marketing</Link>
                </h6>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-0-8s">
                <div className="icon">
                  <i className="flaticon flaticon-cloud-servers"></i>
                </div>
                <h6>
                  <Link to="/services">Cloud Services</Link>
                </h6>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-0-9s">
                <div className="icon">
                  <i className="flaticon flaticon-prototype"></i>
                </div>
                <h6>
                  <Link to="/services">UI/UX Services</Link>
                </h6>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-1-0s">
                <div className="icon">
                  <i className="flaticon flaticon-graphic-design"></i>
                </div>
                <h6>
                  <Link to="/services">Graphic Designing</Link>
                </h6>
              </div>
            </div>

            <div className="col-xl-2 col-lg-3 col-sm-4 col-6 col-small">
              <div className="service-style-two wow fadeInUp delay-1-2s">
                <div className="icon">
                  <i className="flaticon flaticon-web-programming"></i>
                </div>
                <h6>
                  <Link to="/services">Online Courses</Link>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="section-title-with-btn rpt-150">
          <div className="section-title text-white mb-10">
            <h2>
              Preparing for your success <br />
              trusted source in IT services.
            </h2>
          </div>
          <Link to="/services"><span className="theme-btn style-two mb-10">View All Services</span></Link>
        </div>
      </div>
    </section>
  );
}

export default Services;
